import { CustomDatabaseValue } from '@smooved/core';
import { SearchableDropdownInputOption } from '@smooved/ui';

export const otherOption: SearchableDropdownInputOption = {
    id: CustomDatabaseValue.Other,
    value: CustomDatabaseValue.Other,
    labelResource: 'UI.OTHER',
};
